module.exports = {
  messages: {
    CRATE_MASTER_DIRECTORY_BREADCRUMB_HOME: 'Find jobs',
    CRATE_MASTER_DIRECTORY_COMPANIES_HEADLINE:
      'Popular companies starting with {letter}',
    CRATE_MASTER_DIRECTORY_DESCRIPTION:
      'Here you’ll find an overview of all popular jobs, locations, and companies starting with the letter {letter}.',
    CRATE_MASTER_DIRECTORY_HEADLINE:
      'Jobs, locations, and companies starting with {letter}',
    CRATE_MASTER_DIRECTORY_HEADLINE_OTHERS:
      'Jobs and companies starting with {letter}',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_DESCRIPTION:
      'Here are all the searches for {jobRole} on XING',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_FREELANCE: '{jobRole} self-employed jobs',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_HEADLINE: 'Popular searches for {jobRole}',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_LOCATIONS_HEADLINE:
      'Popular locations for {jobRole}',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_PART_TIME: '{jobRole} part-time jobs',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_SKILLS_HEADLINE:
      'Popular skills for {jobRole}',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_STUDENT: '{jobRole} student jobs',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_TEMP_JOBS: '{jobRole} temp jobs',
    CRATE_MASTER_DIRECTORY_JOB_ROLE_TITLE: 'All searches for {jobRole} - XING',
    CRATE_MASTER_DIRECTORY_JOBS_HEADLINE: 'Popular jobs starting with {letter}',
    CRATE_MASTER_DIRECTORY_LOCATIONS_HEADLINE:
      'Popular locations starting with {letter}',
    CRATE_MASTER_DIRECTORY_MORE_BUTTON: 'More',
    CRATE_MASTER_DIRECTORY_SEARCH_BY_LETTERS: 'Search by first letter',
    CRATE_MASTER_DIRECTORY_SKILL_DESCRIPTION:
      'Here are all the locations for {skill} jobs listed in the XING jobs directory',
    CRATE_MASTER_DIRECTORY_SKILL_HEADLINE: 'All locations for {skill}',
    CRATE_MASTER_DIRECTORY_SKILL_TITLE: 'All searches for {skill} - XING',
    CRATE_MASTER_DIRECTORY_SPECIAL_CHARACTERS: 'special characters',
    CRATE_MASTER_DIRECTORY_TITLE:
      'Jobs, locations, and companies starting with {letter}',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Location',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER: 'Enter a job title',
    JOBS_RECENT_SEARCH_EMPTY: 'All jobs',
    JOBS_SEARCH_AI_SALARY_SUGGESTION: 'I want to earn more',
    JOBS_SEARCH_AI_SALARY_SUGGESTION_SUBTITLE: 'Find better-paying jobs',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Search with my profile',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE: 'Discover your next step',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION: 'Change careers',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      'Discover entirely new career paths.',
  },
};
